import { Controller } from "@hotwired/stimulus"

const ACTIVE_TAB_CLASSES = ["border-b-2", "border-indigo-500", "text-indigo-600", "font-medium"]
const INACTIVE_TAB_CLASSES = ["text-gray-500", "hover:text-gray-700"]

export default class extends Controller {
  static targets = ["pasteArea", "container", "template", "choice", "pasteTab", "individualTab", "pastePanel", "individualPanel"]

  connect() {
    const hasExistingChoices = this.choiceTargets.length > 0
    if (hasExistingChoices) {
      this.#applyTabStyles(false)
      this.pastePanelTarget.classList.add("hidden")
      this.individualPanelTarget.classList.remove("hidden")
    } else {
      this.#applyTabStyles(true)
    }
  }

  switchTab(event) {
    const isPaste = event.currentTarget === this.pasteTabTarget
    this.#applyTabStyles(isPaste)
    this.pastePanelTarget.classList.toggle("hidden", !isPaste)
    this.individualPanelTarget.classList.toggle("hidden", isPaste)
  }

  expand() {
    const text = this.pasteAreaTarget.value.trim()
    if (!text) return

    const lines = text.split("\n").map(line => line.trim()).filter(line => line.length > 0)

    lines.forEach(line => {
      this.#appendChoice(line)
    })

    this.pasteAreaTarget.value = ""
    this.#applyTabStyles(false)
    this.pastePanelTarget.classList.add("hidden")
    this.individualPanelTarget.classList.remove("hidden")
  }

  addChoice() {
    this.#appendChoice("")
  }

  removeChoice(event) {
    const choiceElement = event.target.closest("[data-choices-paste-target='choice']")
    if (!choiceElement) return

    const destroyFlag = choiceElement.querySelector("[data-choices-paste-target='destroyFlag']")
    if (destroyFlag && destroyFlag.name.includes("[id]") === false) {
      const idField = choiceElement.querySelector("input[name*='[id]']")
      if (idField) {
        destroyFlag.value = "1"
        choiceElement.classList.add("hidden")
        return
      }
    }

    choiceElement.remove()
  }

  #applyTabStyles(isPaste) {
    if (isPaste) {
      this.pasteTabTarget.classList.add(...ACTIVE_TAB_CLASSES)
      this.pasteTabTarget.classList.remove(...INACTIVE_TAB_CLASSES)
      this.individualTabTarget.classList.remove(...ACTIVE_TAB_CLASSES)
      this.individualTabTarget.classList.add(...INACTIVE_TAB_CLASSES)
    } else {
      this.individualTabTarget.classList.add(...ACTIVE_TAB_CLASSES)
      this.individualTabTarget.classList.remove(...INACTIVE_TAB_CLASSES)
      this.pasteTabTarget.classList.remove(...ACTIVE_TAB_CLASSES)
      this.pasteTabTarget.classList.add(...INACTIVE_TAB_CLASSES)
    }
  }

  #appendChoice(bodyValue) {
    const template = this.templateTarget
    // NOTE: ループ内で連続呼び出しすると Date.now() が同一値になり nested attributes のキーが衝突して 1 件しか保存されないため、 カウンターでユニーク化する
    this.indexCounter = (this.indexCounter || Date.now()) + 1
    const index = this.indexCounter
    const content = template.innerHTML.replace(/INDEX/g, index)

    const wrapper = document.createElement("div")
    wrapper.innerHTML = content
    const newChoice = wrapper.firstElementChild

    const bodyInput = newChoice.querySelector("input[type='text']")
    if (bodyInput) bodyInput.value = bodyValue

    this.containerTarget.appendChild(newChoice)
  }
}
